// extracted by mini-css-extract-plugin
export default {"wrapper":"XyQ7XtdUWxhKnDhhgQYO","emptyCell":"OduMhdZvXXMmbNtivrYB"};